import { Outlet, Link, useLocation } from 'react-router-dom';
import './AdminLayout.css';

function AdminLayout() {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <Link to="/" className="back-link">
            &larr; Back to Site
          </Link>
          <h2>Admin Dashboard</h2>
        </div>
        
        <nav className="sidebar-nav">
          <Link 
            to="/admin" 
            className={`sidebar-link ${location.pathname === '/admin' ? 'active' : ''}`}
          >
            Overview
          </Link>
          <Link 
            to="/admin/content" 
            className={`sidebar-link ${isActive('/admin/content') ? 'active' : ''}`}
          >
            Content Explorer
          </Link>
          <Link 
            to="/admin/domains" 
            className={`sidebar-link ${isActive('/admin/domains') ? 'active' : ''}`}
          >
            Domains
          </Link>
          <Link 
            to="/admin/crawl-queue" 
            className={`sidebar-link ${isActive('/admin/crawl-queue') ? 'active' : ''}`}
          >
            Crawl Queue
          </Link>
          <Link 
            to="/admin/removals" 
            className={`sidebar-link ${isActive('/admin/removals') ? 'active' : ''}`}
          >
            Removal Requests
          </Link>
          <Link 
            to="/admin/budget" 
            className={`sidebar-link ${isActive('/admin/budget') ? 'active' : ''}`}
          >
            Budget & Usage
          </Link>
        </nav>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
